<template>
    <CommonList
            :has-more-search="false"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            selection-type="checkbox"
            row-key="id"
            @selection-change="handleSelectionChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <!-- 操作按钮区 -->
        <template #btn-group>
            <el-button type="primary" class="list-btn" @click="handleUpdateCheckCycle">
                更新年检周期
            </el-button>
            <span class="selected-count" v-if="selectedRows.length > 0">已选 {{ selectedRows.length }} 条</span>
        </template>

        <!-- 固定搜索区 -->
        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">预约状态：</label>
                <el-select v-model="searchForm.appointmentFilter" class="common-input100" placeholder="请选择">
                    <el-option v-for="item in appointmentFilterOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">车牌号：</label>
                <el-input v-model="searchForm.plateNumber" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">车主姓名：</label>
                <el-input v-model="searchForm.userName" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">车架号：</label>
                <el-input v-model="searchForm.vin" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">检车状态：</label>
                <el-select v-model="searchForm.checkStatus" class="common-input100" placeholder="请选择" clearable>
                    <el-option v-for="item in checkStatusOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">流程状态：</label>
                <el-select v-model="searchForm.processStatus" class="common-input100" placeholder="请选择" clearable>
                    <el-option v-for="item in processStatusOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </template>

        <!-- 表格列 -->
        <template #table-column>
            <el-table-column prop="userName" label="车主姓名" align="center" width="120"></el-table-column>
            <el-table-column prop="plateNumber" label="车牌号" align="center" width="120"></el-table-column>
            <el-table-column prop="checkExpireDate" label="检验到期日" align="center" width="120"></el-table-column>
            <el-table-column prop="checkType" label="检车类型" align="center" width="100"></el-table-column>
            <el-table-column prop="windowNo" label="窗口号" align="center" width="80"></el-table-column>
            <el-table-column prop="appointmentType" label="预约类型" align="center" width="130">
                <template #default="scope">
                    {{ appointmentTypeMap[scope.row.appointmentType] || '-' }}
                </template>
            </el-table-column>
            <el-table-column label="预约时间" align="center" width="140">
                <template #default="scope">
                    <div>{{ scope.row.appointmentDate || '-' }}</div>
                    <div>{{ scope.row.appointmentTime || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="contactPhone" label="联系电话" align="center" width="120"></el-table-column>
            <el-table-column prop="agentPhone" label="带检人电话" align="center" width="120"></el-table-column>
            <el-table-column prop="processStatus" label="流程状态" align="center" width="140">
                <template #default="scope">
                    <div class="process-flow">
                        <div class="process-flow-row">
                            <button
                                :class="['flow-btn', { active: scope.row.processStatus === '0', disabled: !['2','3','4'].includes(scope.row.checkStatus) }]"
                                :disabled="!['2','3','4'].includes(scope.row.checkStatus)"
                                @click="handleFieldChange(scope.row, 'processStatus', '0', '正常', '流程状态')"
                            >正常</button>
                            <button
                                :class="['flow-btn', { active: scope.row.processStatus === '1', disabled: !['2','3','4'].includes(scope.row.checkStatus) }]"
                                :disabled="!['2','3','4'].includes(scope.row.checkStatus)"
                                @click="handleFieldChange(scope.row, 'processStatus', '1', '暂停', '流程状态')"
                            >暂停</button>
                        </div>
                        <button
                            :class="['flow-btn', { active: scope.row.processStatus === '2', disabled: scope.row.processStatus !== '1' }]"
                            :disabled="scope.row.processStatus !== '1'"
                            @click="handleFieldChange(scope.row, 'processStatus', '2', '处理中', '流程状态')"
                        >处理中</button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="checkStatus" label="检车状态" align="center" width="360">
                <template #default="scope">
                    <div class="check-flow">
                        <template v-for="(label, idx) in checkFlowSteps" :key="idx">
                            <!-- 未预约列表：只显示"已到站"按钮；已取证：只显示已取证+已年检 -->
                            <template v-if="(searchForm.appointmentFilter !== 'unbooked' || idx === 1) && shouldShowCheckButton(scope.row, idx)">
                                <button
                                        :class="['flow-btn', { active: idx === Number(scope.row.checkStatus), disabled: isCheckButtonDisabled(scope.row, idx) }]"
                                        :disabled="isCheckButtonDisabled(scope.row, idx)"
                                        @click="handleFieldChange(scope.row, 'checkStatus', String(idx), label, '检车状态')"
                                >{{ label }}</button>
                                <span v-if="idx < checkFlowSteps.length - 1" class="flow-arrow">›</span>
                                <div v-if="idx === 3" class="flow-break"></div>
                            </template>
                        </template>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="auto" :resizable="false">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="handleUpdateCheckInfo(scope.row)">变更</el-button>
                </template>
            </el-table-column>
        </template>
    </CommonList>

    <!-- 更新检车信息对话框 -->
    <el-dialog v-model="updateDialogVisible" title="更新检车信息" width="640px" :close-on-click-modal="false">
        <div class="update-dialog-content">
            <!-- 车辆信息区（仅查看） -->
            <div class="dialog-section">
                <div class="section-header">
                    <span class="section-bar"></span>
                    <h4 class="section-title">车辆信息</h4>
                    <span class="section-tag">仅查看</span>
                </div>
                <div class="info-card">
                    <div class="info-grid">
                        <div class="info-item">
                            <label>车牌号</label>
                            <span>{{ updateForm.plateNumber || '-' }}</span>
                        </div>
                        <div class="info-item">
                            <label>车架号</label>
                            <span>{{ updateForm.vin || '-' }}</span>
                        </div>
                        <div class="info-item">
                            <label>车辆类型</label>
                            <span>{{ updateForm.vehicleType || '-' }}</span>
                        </div>
                        <div class="info-item">
                            <label>使用性质</label>
                            <span>{{ updateForm.useNature || '-' }}</span>
                        </div>
                        <div class="info-item">
                            <label>注册日期</label>
                            <span>{{ updateForm.registerDate || '-' }}</span>
                        </div>
                        <div class="info-item">
                            <label>车辆状态</label>
                            <span class="status-text">{{ vehicleStatusText }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 年检信息区（可编辑） -->
            <div class="dialog-section">
                <div class="section-header">
                    <span class="section-bar"></span>
                    <h4 class="section-title">年检信息</h4>
                    <span class="section-tag editable">可编辑</span>
                    <el-popover placement="right" trigger="click" :width="380">
                        <template #reference>
                            <el-button type="primary" link size="small" class="rule-btn">规则</el-button>
                        </template>
                        <div class="rule-content">
                            <p class="rule-title">日期选择规则</p>
                            <ul class="rule-list">
                                <li>只能选择<b>当年</b>的<b>月份</b>（日历和后端双重校验）</li>
                                <li>选中月份后自动取该月<b>最后一天</b>作为检验到期日</li>
                                <li>月份变化时，原检车记录会归档到历史表，新记录状态清空</li>
                                <li>移历史表前会删除同VIN+年份的旧历史记录（避免唯一索引冲突）</li>
                            </ul>
                            <p class="rule-title">更新结果说明</p>
                            <ul class="rule-list">
                                <li><b>往后推</b>（如8月→11月）：正常调整到期日，不影响检车流程</li>
                                <li><b>往前推未过期</b>（如8月→7月）：纠错到期日，正常预约检车</li>
                                <li><b>往前推已过期</b>（如8月→6月，今天7月）：补检场景，可正常预约</li>
                            </ul>
                        </div>
                    </el-popover>
                </div>
                <div class="info-card editable-card">
                    <el-form label-width="110px">
                        <el-form-item label="检验周期/月" help="单独更新周期，可反复调整">
                            <el-input-number v-model="updateForm.checkCycle" :controls="false" :min="1" :max="60" :precision="0" placeholder="请输入月份" style="width: 140px;"></el-input-number>
                            <el-button type="primary" size="small" @click="saveCheckCycle" :loading="cycleLoading" style="margin-left: 10px;">更新周期</el-button>
                        </el-form-item>
                        <el-row :gutter="16">
                            <el-col :span="12">
                                <el-form-item label="检验到期日" help="只能选择当年的月份，自动取当月最后一天">
                                    <el-date-picker
                                        v-model="updateForm.checkExpireDate"
                                        type="month"
                                        format="YYYY-MM-DD"
                                        value-format="YYYY-MM-DD"
                                        placeholder="选择月份"
                                        :disabled-date="disabledDate"
                                        style="width: 100%;"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="检车类型">
                                    <el-select v-model="updateForm.checkType" placeholder="请选择" style="width: 100%;">
                                        <el-option label="年检" value="年检"></el-option>
                                        <el-option label="免检" value="免检"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="center-button-wrapper">
                            <el-button type="primary" @click="saveAllCheckInfo" :loading="allLoading">全部更新</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </el-dialog>

    <!-- 现场检车预约 - 补充联系电话和带检人电话 -->
    <el-dialog
            v-model="supplementDialog.visible"
            :title="'补充预约信息 - ' + supplementDialog.plateNumber"
            width="460px"
            :close-on-click-modal="false"
            append-to-body>
        <el-form :model="supplementForm" ref="supplementFormRef" label-width="100px">
            <el-form-item label="联系电话" prop="contactPhone"
                          :rules="[{ required: true, message: '请输入客户手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }]">
                <el-input v-model="supplementForm.contactPhone" placeholder="请输入客户手机号（必填，11位）" maxlength="11" clearable />
            </el-form-item>
            <el-form-item label="带检人电话" prop="agentPhone"
                          :rules="supplementForm.agentPhone ? [{ pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }] : []">
                <el-input v-model="supplementForm.agentPhone" placeholder="请输入带检人手机号（选填，11位）" maxlength="11" clearable />
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="supplementDialog.visible = false">取消</el-button>
            <el-button type="primary" :loading="supplementDialog.submitting" @click="submitSupplement">确认提交</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
    import useBillList from './checkHandleList.js'
    const {
        searchForm,
        listRef,
        selectedRows,
        handleLoadList,
        handleReset,
        handleSelectionChange,
        handleUpdateCheckCycle,
        handleUpdateCheckInfo,
        updateDialogVisible,
        updateForm,
        vehicleStatusText,
        disabledDate,
        saveCheckCycle,
        saveAllCheckInfo,
        cycleLoading,
        allLoading,
        appointmentTypeMap,
        checkStatusOptions,
        appointmentFilterOptions,
        processStatusOptions,
        checkFlowSteps,
        shouldShowCheckButton,
        isCheckButtonDisabled,
        handleFieldChange,
        supplementDialog,
        supplementForm,
        submitSupplement
    } = useBillList()
</script>
<style>
    @import '../../../assets/css/util/base-list.css';
    .check-flow {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
    .process-flow {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
    }
    .process-flow-row {
        display: flex;
        gap: 6px;
    }
    .flow-break {
        flex-basis: 100%;
        height: 4px;
    }
    .flow-btn {
        color: #909399;
        font-size: 12px;
        white-space: nowrap;
        border: 1px solid #dcdfe6;
        background-color: #f4f4f5;
        border-radius: 4px;
        padding: 2px 8px;
        cursor: pointer;
        transition: all 0.2s;
    }
    .flow-btn:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
    .flow-btn.active {
        color: #ffffff;
        background-color: #409eff;
        border-color: #409eff;
        font-weight: 600;
    }
    .flow-btn:disabled,
    .flow-btn.disabled {
        color: #c0c4cc;
        background-color: #f4f4f5;
        border-color: #e4e7ed;
        cursor: not-allowed;
        opacity: 0.6;
    }
    .flow-btn:disabled:hover,
    .flow-btn.disabled:hover {
        color: #c0c4cc;
        border-color: #e4e7ed;
        background-color: #f4f4f5;
    }
    /* 禁用状态下当前状态仍保持高亮（能看出当前是什么状态），仅鼠标变禁止 */
    .flow-btn.active:disabled,
    .flow-btn.active.disabled {
        color: #ffffff;
        background-color: #409eff;
        border-color: #409eff;
        font-weight: 600;
        opacity: 1;
        cursor: not-allowed;
    }
    .flow-arrow {
        color: #c0c4cc;
        margin: 0 3px;
        font-size: 12px;
    }
    .selected-count {
        margin-left: 12px;
        font-size: 14px;
        color: #409eff;
        font-weight: 600;
    }
    .update-dialog-content {
        max-height: 60vh;
        overflow-y: auto;
        padding-right: 8px;
    }
    .dialog-section {
        margin-bottom: 20px;
    }
    .dialog-section:last-child {
        margin-bottom: 0;
    }
    .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
    .section-bar {
        width: 4px;
        height: 16px;
        background: #409eff;
        border-radius: 2px;
        margin-right: 8px;
    }
    .section-title {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #303133;
    }
    .section-tag {
        margin-left: 10px;
        padding: 2px 8px;
        font-size: 12px;
        color: #909399;
        background: #f4f4f5;
        border-radius: 10px;
    }
    .section-tag.editable {
        color: #409eff;
        background: #ecf5ff;
    }
    .rule-btn {
        margin-left: auto;
        padding: 0;
    }
    .rule-content .rule-title {
        margin: 0 0 8px 0;
        font-size: 13px;
        font-weight: 600;
        color: #303133;
    }
    .rule-content .rule-list {
        margin: 0 0 12px 0;
        padding-left: 18px;
        color: #606266;
        font-size: 12px;
        line-height: 1.8;
    }
    .rule-content .rule-list:last-child {
        margin-bottom: 0;
    }
    .rule-content .rule-list b {
        color: #303133;
    }
    .info-card {
        background: #fafafa;
        border-radius: 6px;
        padding: 16px 20px;
    }
    .editable-card {
        background: #fff;
        border: 1px solid #d9ecff;
        background: #f5fbff;
    }
    .info-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px 24px;
    }
    .info-item label {
        display: block;
        color: #909399;
        font-size: 13px;
        margin-bottom: 4px;
    }
    .info-item span {
        color: #303133;
        font-size: 14px;
        line-height: 1.5;
    }
    .info-item .status-text {
        color: #67c23a;
        font-weight: 500;
    }
    .cycle-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .center-button-wrapper {
        text-align: center;
        margin-top: 8px;
    }
    /* 双列表单样式调整 */
    .editable-card .el-col .el-form-item {
        margin-bottom: 0;
    }
</style>
